module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_9016.8af5e909.png";